import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { CasoGeneralComponent } from 'reccol-caso-general'
import AdministracionForm from './formulario'
import { obtenerDatosLlaves } from '../../store/actions/recepciona-caso-action'
import { Auth } from 'recupero-comunes'
import { useLocation } from 'react-router-dom'
import { Card, Container} from 'react-bootstrap'
import 'recupero-comunes/dist/index.css'

const ProcesoExtrajudicial = () => {
  const {state}=useLocation()
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :390
  const idImplicado=1;//(SE DEJA IMPLICADO 1 EN DURO A LA ESPERA DE SELECCIONARLO DESDE COMBO) state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.IdOrganizacionCaso  ? state.row.IdOrganizacionCaso:8600399880
    
  const { rutUsuario } = Auth.currentUser()

const dispatch = useDispatch()

  useEffect(() => {

    dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso, "idUsuario": rutUsuario}));
  
  }, [dispatch])

  return (
    <div>    
      <Container>
        <Card className='mt-2'>
          <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{`Gestión Caso Asignado ${idCasoLocation}`}</Card.Header>
          <Card.Body>
            <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
        </Card.Body>
        </Card>
      </Container>
      <AdministracionForm />      
    </div>
  )
}

export default ProcesoExtrajudicial 